// extracted by mini-css-extract-plugin
export default {"linksContainer":"GlobalFooter_linksContainer__z77VH","backgroundGrey":"GlobalFooter_backgroundGrey__PSC-y","disclosureTextContainer":"GlobalFooter_disclosureTextContainer__sIuUx"};